var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPassOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 174 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient-0",
    x1: 153.038,
    y1: 184.264,
    x2: 102.967,
    y2: 124.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 174,
    height: 174,
    fill: "url(#Gradient-0)",
    transform: "translate(87,87) scale(-1,1) translate(-87,-87)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.81 154.959c0-1.217 .98-2.204 2.19-2.204c1.21 0 2.191 .987 2.191 2.204h-4.381Zm-1.461 0h-2.19c-0.403 0-0.73 .329-0.73 .735v10.286c0 .405 .327 .734 .73 .734h11.682c.404 0 .731-0.329 .731-0.734v-10.286c0-0.406-0.327-0.735-0.731-0.735h-2.19c0-2.029-1.635-3.673-3.651-3.673c-2.016 0-3.651 1.644-3.651 3.673Zm1.461 2.939c0 1.217 .98 2.204 2.19 2.204c1.21 0 2.191-0.987 2.191-2.204h1.46c0 2.029-1.635 3.673-3.651 3.673c-2.016 0-3.651-1.644-3.651-3.673h1.461Z",
    fill: "#ffc300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPassOverlay);
export default __webpack_public_path__ + "static/media/ic_pass_overlay.2c290c7dbd745430493d6fc657166a2c.svg";
export { ForwardRef as ReactComponent };